import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=35bb0034"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports